export const PROJECT_STATUS = {
	0: 'DELETED',
	1: 'EDITION',
	2: 'ORDER'
}

export const ENABLED_BUTTONS_BY_STATUS = {
	DELETED: [],
	EDITION: ['EDIT_PROJECT_NAME', 'DELETE_PROJECT'],
	ORDER: []
}
